import { inject, Injectable, resource } from '@angular/core';
import { SonaAuthApiFacade } from '@sona/angular-auth-api';
import { OrganizationId } from '@sona/shared-model-common';
import { firstValueFrom } from 'rxjs';

import { OrganizationApiService } from '../../infrastructure/services/organization-api.service';

@Injectable({
    providedIn: 'root'
})
export class OrganizationSwitcherFacade {
    private readonly _authFacade = inject(SonaAuthApiFacade);
    private readonly _organizationApi = inject(OrganizationApiService);

    readonly isSwitchingOrganization = this._authFacade.switchOrganization.isMutating;
    readonly currentOrganizationId = this._authFacade.organizationId;
    readonly currentOrganization = this._authFacade.organization;

    getOrganizations() {
        return resource({
            request: () => ({ currentOrganization: this._authFacade.organization.hasValue() ? this._authFacade.organization.value() : undefined }),
            loader: () => firstValueFrom(this._organizationApi.getUserOrganizations())
        });
    }

    /**
     * Switch to a different organization
     */
    async switchOrganization(organizationId: OrganizationId) {
        await this._authFacade.switchOrganization.mutate({ organizationId });
    }
}